import { Box } from "@mui/material"
import { useRecordContext } from "react-admin"
import { InvoiceReadModel } from "../../../GeneratedClients/FreeBillApi"
import InvoiceStateMenu from "./InvoiceStateMenu"
import InvoiceStateChip from "./InvoiceStateChip"

const InvoiceStateComponent = () => {
  const record = useRecordContext<InvoiceReadModel>()
  if(!record) return null

  return (
    <Box textAlign={'end'}>
      <InvoiceStateChip invoice={record} />
			<InvoiceStateMenu />
    </Box>

  )
}

export default InvoiceStateComponent
